import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { employeeLogin } from '../../service/api/Employee/apiEmployee';
import { useUser, saveUserToCookie } from '../../hooks/useUser';
import '../../css/components/EmployeeLogin.css';
import { roleConfig } from '../../constants/roleConfig';

const EmployeeLogin = () => {
    const navigate = useNavigate();
    const { isLoggedIn, role } = useUser();

    // 如果已登入，重定向到 /delivery
    useEffect(() => {
        if (isLoggedIn && role <= roleConfig['財務']) {
            navigate('/delivery', { replace: true });
        }else if (isLoggedIn && role > roleConfig['財務']) {
            navigate('/SKAManager', { replace: true });
        }
    }, [navigate, isLoggedIn, role]);

    // 從 Cookie 初始化狀態
    const rememberedEmail = Cookies.get('rememberedEmail');
    const rememberMeStatus = Cookies.get('rememberMeStatus') === 'true';

    const [email, setEmail] = useState(rememberedEmail || '');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [rememberMe, setRememberMe] = useState(rememberMeStatus);

    const handleRememberMeChange = (e) => {
        const isChecked = e.target.checked;
        setRememberMe(isChecked);
        // 立即保存到 Cookie
        Cookies.set('rememberMeStatus', isChecked, { expires: 30 });
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await employeeLogin(email, password);

            if (response.status === 200 && response.data.status === 1) {
                const { token, id, name, role, email, phone, companyId } = response.data.result;

                // 使用 saveUserToCookie 保存用戶信息
                saveUserToCookie({ token, id, name, role, email, phone, companyId });

                // 保存 rememberMe 偏好設置
                Cookies.set('rememberMeStatus', rememberMe, { expires: 30 });

                // 如果勾選記住我，保存郵箱
                if (rememberMe) {
                    Cookies.set('rememberedEmail', email, { expires: 30 });
                } else {
                    Cookies.remove('rememberedEmail');
                }

                // 重定向到首頁
                if (role <= roleConfig['財務'])
                    navigate('/delivery');
                else
                    navigate('/SKAManager');
            } else {
                setError(response.data.message || '登入失敗');
                // 即使登入失敗，也保存 rememberMe 偏好設置
                Cookies.set('rememberMeStatus', rememberMe, { expires: 30 });
            }
        } catch (err) {
            setError(err.data?.message || '帳號或密碼錯誤');
            console.error('Login error:', err);
            // 即使登入失敗，也保存 rememberMe 偏好設置
            Cookies.set('rememberMeStatus', rememberMe, { expires: 30 });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="employee-login-container">
            <div className="login-box">
                <div className="login-header">
                    <h1>帳號登入</h1>
                    <p>家具公車系統管理</p>
                </div>

                <form onSubmit={handleLogin} className="login-form">
                    {error && <div className="error-message">{error}</div>}

                    <div className="form-group">
                        <label htmlFor="email">電子郵件</label>
                        <input
                            type="email"
                            id="email"
                            className="form-input"
                            placeholder="請輸入電子郵件"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            disabled={loading}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="password">密碼</label>
                        <input
                            type="password"
                            id="password"
                            className="form-input"
                            placeholder="請輸入密碼"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            disabled={loading}
                        />
                    </div>

                    <div className="form-group checkbox">
                        <input
                            type="checkbox"
                            id="rememberMe"
                            checked={rememberMe}
                            onChange={handleRememberMeChange}
                            disabled={loading}
                        />
                        <label htmlFor="rememberMe">記住我</label>
                    </div>

                    <button
                        type="submit"
                        className="login-button"
                        disabled={loading}
                    >
                        {loading ? '登入中...' : '登入'}
                    </button>
                </form>

                <div className="login-footer">
                    <p>遇到問題？請聯繫系統管理員</p>
                </div>
            </div>
        </div>
    );
};

export default EmployeeLogin;
